import React from "react";
import { AiOutlineCheck } from "react-icons/ai";
import image_1 from "../../images/afro-academy/Picture13.png";

const JumpstartCareer = () => {
  return (
    <section className="">
      <div className="bg-american-yellow text-white text-center pt-7 pb-7 ">
        <h1 className="fs-56 lh-64 gilroy-bold">Jumpstart your Career</h1>
        <h2 className="fs-56 lh-64 gilroy-bold">
          AFRO Training of Trainers (TOT)
        </h2>
        <p className="fs-20 lh-30">
          Get the skills you need for becoming a professional Trainer <br /> in
          just 3 months.
        </p>
      </div>
      <div className="me-47 ms-47 fs-16 lh-30 pt-7 pb-7">
        <p>
          Enroll in AFRO Academy today and, for as few as 10 hours a week, you
          can get the in-demand skills you need to become a professional
          instructor, trainer, coach and mentor. Learn at your own pace, when
          and where it's convenient for you.
        </p>
        <p>Get TOT Diploma when you complete 750 credit points:</p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          Create your own career path by choosing the modules
        </p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          Credit points based on skill levels & real-life projects
        </p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          Unlimited FREE access to ustaze.com with $100K+ of courses, templates,
          books.
        </p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          TOT Coaching Sessions 50+ hours{" "}
        </p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          Built in partnership with the world’s most innovative tech companies
        </p>
        <p>
          <span>
            <AiOutlineCheck className="text-orange-ryb fs-20 me-2 me-md-4" />
          </span>
          Taught by with mentorship & coaching from and industry leaders.
        </p>
      </div>
      <div className="py-5 px-5 px-lg-0" style={{ backgroundColor: "#023c7a" }}>
        <div className="d-flex justify-content-evenly justify-content-md-around align-items-center">
          <div>
            <h3 className="fs-56 lh-64 gilroy-bold text-white">
              Learn with top Industry Experts & Executives
            </h3>
          </div>
          <div>
            <img src={image_1} loading="lazy" className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JumpstartCareer;
